import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

interface Props {
  handleClockIn: () => void;
  handleClockOut: () => void;
  handleBreakToggle: () => void;
  handleLunchToggle: () => void;
  isOnBreak: boolean;
  isOnLunch: boolean;
  isWorking: boolean;
  clockInTime: any | null;
  clockOutTime: any | null;
}

const TimeTrackingButtons: React.FC<Props> = ({
  handleClockIn,
  handleClockOut,
  handleBreakToggle,
  handleLunchToggle,
  isOnBreak,
  isOnLunch,
  isWorking,
  clockInTime,
  clockOutTime
}) => {
  const clockedIn = !!isWorking;

  return (
    <View className="flex-row flex-wrap justify-center items-center gap-3">

      {/* Clock In */}
      {!clockedIn && (
        <TouchableOpacity
          onPress={handleClockIn}
          className="bg-green-500 px-4 py-2 rounded-2xl flex-row items-center"
        >
          <MaterialCommunityIcons name="clock-check-outline" size={20} color="white" />
          <Text className="text-white font-semibold ml-2">Clock In</Text>
        </TouchableOpacity>
      )}

      {/* Clocked In actions */}
      {clockedIn && (
        <>
          {/* Clock Out - always visible when clocked in */}
          <TouchableOpacity
            onPress={handleClockOut}
            className="bg-red-500 px-4 py-2 rounded-2xl flex-row items-center"
          >
            <MaterialCommunityIcons name="clock-outline" size={20} color="white" />
            <Text className="text-white font-semibold ml-2">Clock Out</Text>
          </TouchableOpacity>

          {/* Break Toggle - ONLY if not on lunch */}
          {!isOnLunch && (
            <TouchableOpacity
              onPress={handleBreakToggle}
              className={`px-4 py-2 rounded-2xl flex-row items-center ${
                isOnBreak ? "bg-orange-400" : "bg-orange-300"
              }`}
            >
              <MaterialCommunityIcons name="coffee-outline" size={20} color={isOnBreak ? "white" : "black"} />
              <Text className={`font-semibold ml-2 ${isOnBreak ? "text-white" : "text-black"}`}>
                {isOnBreak ? "Back from Break" : "Take Break"}
              </Text>
            </TouchableOpacity>
          )}

          {/* Lunch Toggle - ONLY if not on break */}
          {!isOnBreak && (
            <TouchableOpacity
              onPress={handleLunchToggle}
              className={`px-4 py-2 rounded-2xl flex-row items-center ${
                isOnLunch ? "bg-yellow-500" : "bg-cyan-300"
              }`}
            >
              <MaterialCommunityIcons name="food-outline" size={20} color={isOnLunch ? "white" : "black"} />
              <Text className={`font-semibold ml-2 ${isOnLunch ? "text-white" : "text-black"}`}>
                {isOnLunch ? "Back from Lunch" : "Go to Lunch"}
              </Text>
            </TouchableOpacity>
          )}
        </>
      )}
    </View>
  );
};


export default TimeTrackingButtons;
